<template>
  <BaseCard v-test="'billing-faq-card'">
    <Flex direction="column">
      <BaseHeading>{{ t('admin.billing.faq.heading') }}</BaseHeading>
      <BaseAccordion
        v-model="activeKeys"
        :titles="items.map((item) => item.question)"
      >
        <template
          v-for="(item, index) in items"
          :key="item.id"
          #[String(index+1)]
        >
          {{ item.answer }}
        </template>
      </BaseAccordion>
    </Flex>
  </BaseCard>
</template>
<script
  lang="ts"
  setup
>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { brandName } from '@/helpers/brand-name';
import { useCompanyStore } from '@/stores/company';

const activeKeys = ref([]);
const { t } = useI18n();
const { company } = useCompanyStore();

const items = Array.from({ length: 11 }, (_, index) => ({
  id: index,
  question: t(`admin.billing.faq.question_${index + 1}`),
  answer: t(`admin.billing.faq.answer_${index + 1}`, brandName()),
})).filter((item) => !(company.freeEmployees && item.id === 6));
// filtering out the item with id 6 for free employees accounts
</script>
